const objSexo = [
    {
        id: null,
        codigo: "F",
        descripcion: "Mujer"
    },
    {
        id: null,
        codigo: "M",
        descripcion: "Hombre"
    },
];
export default objSexo;